/** The field order of a rendered date that shows its year. */
export enum DateOrder {
    MonthFirst = 'monthFirst',
    DayFirst = 'dayFirst',
    YearFirst = 'yearFirst',
}

/** How the UI writes a clock and a date for the operator. */
export interface DisplayFormat {
    isHour24: boolean;
    dateOrder: DateOrder;
}
